<template>
  <b-row>
    <b-col lg="12">
      <!-- .name -->
      <validation-observer ref="registerForm" #default="{ invalid }">
        <b-form>
          <b-row>
            <!-- .name -->
            <b-col lg="12">
              <b-form-group
                id="input-group-1"
                :label="$t('questions.question')"
                label-for="input-1"
              >
                <validation-provider
                  #default="{ errors }"
                  name="question"
                  vid="question"
                  rules="required"
                >
                  <b-form-input
                    id="input-1"
                    v-model="newItem.question"
                    type="text"
                    :placeholder="$t('questions.question')"
                    :state="errors.length > 0 ? false : null"
                  >
                  </b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <!-- .name -->
            <b-col lg="9">
              <b-form-group
                id="input-group-1"
                :label="$t('questions.answer')"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="answertext"
                  type="text"
                  :placeholder="$t('questions.answer')"
                >
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-button
                variant="success"
                block
                style="margin-top: 23px"
                @click="add()"
                :disabled="answertext.length < 2"
              >
                <i class="fa fa-plus" /> {{ $t("site.add") }}</b-button
              >
            </b-col>
            <b-col md="12">
              <b-list-group>
                <b-list-group-item
                  v-for="(item, index) in newItem.poll_answer"
                  :key="index"
                >
                  <b-row>
                    <b-col md="9">
                      {{ item.answer }}
                    </b-col>
                    <b-col md="3">
                      <b-button
                        variant="danger"
                        block
                       
                        @click="deleteItem()"
                        
                      >
                        <i class="fa fa-trash"></i
                        >{{ $t("site.delete") }}</b-button
                      >
                    </b-col>
                  </b-row>
                </b-list-group-item>
              </b-list-group>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col lg="6">
              <b-button
                block
                :disabled="invalid"
                variant="primary"
                @click="submit()"
              >
                <i class="fa fa-plus" /> {{ $t("site.save") }}
              </b-button>
            </b-col>
            <b-col lg="6">
              <b-button block  @click="goToTable()"  variant="success">
                <i class="fas fa-ban"></i> {{ $t("site.cancel") }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-col>
  </b-row>
</template>

<script>
import Controller from "../../../../Controllers/PollsQuestionsController";
import config from "../../../../config/config";

import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";

export default {
  name: "PollsQuestionsForm",
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
  },
  props: ["newItem"],
  data() {
    return {
      file: {},
      
      controller: {},
      answertext: "",
    };
  },
  created() {
    this.controller = new Controller(this.$route.params.pollId);
  },
  methods: {
    async    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      let res = await this.controller.From(this.newItem, "FormData");
      if (res) {
        this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
        this.$parent.$parent.firstTab();
      }
    },
    add() {
      if (!this.newItem.poll_answer) {
        this.newItem.poll_answer = [];
      }
      this.newItem.poll_answer.push({ answer: this.answertext });
      this.answertext = "";
    },
    deleteItem(index) {
      this.newItem.poll_answer.splice(index, 1);
    },
    // async created() {
    //    const data = await controller.created();
    //    data.
    // },
  },
};
</script>
